import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { formatUrl } from 'url-lib';
import { useEventCardTrackingContext } from '../EventCardTracking';
import './EventCardLink.scss';
import { EventCardLinkPropGetterConfig, EventCardLinkProps } from './types';
import { getEventCardLinkClickHandlers, getLinkTargetRel } from './utils';

export const getEventCardLinkProps = (
    config: EventCardLinkPropGetterConfig,
): EventCardLinkProps => {
    const formattedUrl = formatUrl(config.url, {
        aff: config.affCode,
    });
    const { target, rel } = getLinkTargetRel(config);
    const clickHandlers = getEventCardLinkClickHandlers(config);

    return {
        href: formattedUrl,
        rel,
        target,
        clickHandlers: clickHandlers,
        className: config.className,
        key: formattedUrl,
        'aria-label':
            config?.label?.toString() || gettext('Event link').toString(),
    };
};

export const EventCardLinkBase: React.FunctionComponent<EventCardLinkProps> = ({
    children,
    ...props
}) => {
    const { clickHandlers, ...remainingProps } = props;

    const handleClick = (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
        clickHandlers.forEach((fn) => fn(e));
    };

    const { heapDataAttributes } = useEventCardTrackingContext();

    return (
        <a
            {...remainingProps}
            className={`event-card-link ${props.className || ''}`}
            onClick={(e) => handleClick(e)}
            data-event-id={heapDataAttributes?.eventId}
            data-event-location={heapDataAttributes?.locationSlug}
            data-event-paid-status={heapDataAttributes?.paidStatus}
            data-event-category={heapDataAttributes?.category}
        >
            {children}
        </a>
    );
};
